module.exports = __webpack_public_path__ + "img/67b22.ea3e5eaa.svg";